import {
  Box,
  Paper,
  Stack,
  Typography,
  Button,
  Skeleton,
  Divider,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { ChevronRight } from "@mui/icons-material";

export default function WidgetCard({
  title,
  icon,
  accent,
  ctaLabel,
  onCta,
  loading = false,
  empty = false,
  emptyLabel = "Nada por aqui ainda.",
  children,
}) {
  const theme = useTheme();
  const color = accent || theme.palette.primary.main;

  const styles = {
    paper: {
      borderRadius: 2,
      display: "flex",
      flexDirection: "column",
      height: "100%",
      overflow: "hidden",
      bgcolor: theme.palette.background.paper,
      boxShadow: "0px 1px 3px rgba(0,0,0,0.05)",
    },
    header: {
      px: 2,
      py: 1.25,
    },
    iconBox: {
      width: 30,
      height: 30,
      borderRadius: 1.5,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color,
      backgroundColor: alpha(color, 0.12),
    },
    title: { fontSize: "15px", fontWeight: 600 },
    cta: {
      textTransform: "none",
      color,
      fontWeight: 500,
      minWidth: 0,
      px: 1,
      fontSize: "0.8rem",
      "&:hover": { backgroundColor: alpha(color, 0.1) },
    },
    body: { px: 1, py: 0.5 },
    empty: {
      py: 4,
      textAlign: "center",
      color: theme.palette.text.secondary,
      fontSize: "0.85rem",
    },
  };

  return (
    <Paper sx={styles.paper} elevation={0}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={styles.header}
      >
        <Stack direction="row" alignItems="center" gap={1.25}>
          {icon && <Box sx={styles.iconBox}>{icon}</Box>}
          <Typography sx={styles.title}>{title}</Typography>
        </Stack>
        {ctaLabel && (
          <Button
            size="small"
            sx={styles.cta}
            endIcon={<ChevronRight sx={{ ml: -0.5 }} />}
            onClick={onCta}
          >
            {ctaLabel}
          </Button>
        )}
      </Stack>

      <Divider />

      {loading ? (
        <Stack gap={1} sx={{ p: 1.5 }}>
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton
              key={i}
              variant="rectangular"
              sx={{ width: "100%", height: 44, borderRadius: 1.5 }}
            />
          ))}
        </Stack>
      ) : empty ? (
        <Typography sx={styles.empty}>{emptyLabel}</Typography>
      ) : (
        <Stack
          sx={styles.body}
          divider={<Divider sx={{ borderStyle: "dashed", opacity: 0.6 }} />}
        >
          {children}
        </Stack>
      )}
    </Paper>
  );
}
